/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Paper, Grid, Modal, Stack, TableContainer, Typography, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { BoxContainer, Container } from "../../components/styledComponent/Common";
import styled from "styled-components";
import BreadCrum from "../../components/layout/BreadCrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { endpoints } from "../../api/endpoints";
import { useCrudForm } from "../../api/useCrudForm";
import { Check, Verified } from "@mui/icons-material";
import { cancelStyle } from "../../components/modal/cancelModalStyle";
import { toast } from "react-toastify";
import { AppContext } from "../../contexts/AppContext";
import moment from "moment";
import { KeyValueText, KeyTxt } from "../../components/styledComponent/Common";
import CustomerInfoText, { TextLoading } from "../../components/customer/customerInfoText";
import { LoadingButton } from "@mui/lab";
import { TableHeadCell } from "../../components/styledComponent/table/TableCell";
import { getStatusColor } from "../../pages/customer/form/DetailsForm";
import { TablePagination } from "../../components/pagination/Pagination";
import { Print } from "@mui/icons-material";
import LockerReleaseFormTemplate from "../../components/print/LockerReleasePrint";

const LayoutNewCustomerReg = styled(Box)`
    padding: 10px 0;
`;

const LockerDetails = () => {
    const [lockerDetails, setLockerDetails] = useState<any | null>();
    const [lockerLogs, setLockerLogs] = useState<any | null>([]);
    const [isApproved, setIsApproved] = useState<boolean>(false);
    const { id } = useParams();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [lockerLoading, setLockerLoading] = useState(true);
    const [skip, setSkip] = useState(0)
    const [take, setTake] = useState(10)
    const [count, setCount] = useState(0)
    const [openPrint, setOpenPrint] = useState(false);
    const [selectedItem, setSelectedItem] = useState<any | null>(null);

    const { get, edit } = useCrudForm();
    const { user } = useContext(AppContext)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isMainTable = queryParams.get('isMainTable');

    useEffect(() => {
        if (id) {
            get({
                endpoints: `${endpoints.locker.get({ id: parseInt(id), isMainTable: isMainTable })}`,
                onSuccess: (data: any) => {
                    const lockerInfo = data.data.existingData ?? data.data.tempData
                    const mapLockerInfo = Object.keys(lockerInfo).reduce((acc: any, key: any) => Object.assign(acc, { [key]: lockerInfo[key] !== '' ? lockerInfo[key] : null, ['temp' + key]: data.data.tempData !== null ? data.data.tempData[key] !== '' ? data.data.tempData[key] : null : undefined, ['isSame' + key]: data.data.tempData == null || data.data.existingData == null ? true : lockerInfo[key] === data.data.tempData[key] }), {})
                    setLockerDetails(mapLockerInfo)
                    setLockerLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    navigate('/lockers')
                }
            })
        }
    }, [id])

    useEffect(() => {
        if (id) {
            fetchLockersLogs(skip ?? 0, take ?? 10, id);
        }

    }, [take, skip, id])

    const fetchLockersLogs = (skip: any, take: any, id: any) => {
        get({
            endpoints: `${endpoints.locker.lockerLogs({ skip: skip, take: take, id: id })}`,
            onSuccess: (data: any) => {
                setCount(data.data.count)
                setLockerLogs(data.data.list)
                setLockerLoading(false)
            },
            onError: (error: any) => {
                toast.error(error?.message ?? error)
                navigate('/lockers')
                console.log(error)
            }
        })
    }

    const handleClose = () => {
        setOpenPrint(false);
        setOpen(false);
    };

    const handleApproveLocker = () => {
        if (id) {
            setLockerLoading(true)
            edit({
                endpoints: endpoints.locker.approved({ lockerId: parseInt(lockerDetails?.tempid ?? id) }),
                onSuccess: (data: any) => {
                    toast.success(data?.message ?? 'Successfully Approved', { style: { background: '#3150A1' } })
                    navigate('/lockers')
                    setLockerLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    setLockerLoading(false)
                },
                values: {}
            })
        }
    }

    useEffect(() => {
        setIsApproved(lockerDetails?.tempisApproved !== undefined ? lockerDetails?.tempisApproved : lockerDetails?.isApproved !== undefined ? lockerDetails?.isApproved : false)
    }, [lockerDetails])

    return (
        <Box>
            <TopBreadcrumbs />

            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h5" component="h2" mt={3} fontWeight={600}>Locker Details</Typography>
                {
                    !lockerLoading ? <Stack direction="row" gap={2} alignItems="center">
                        {
                            isApproved === true ? <Button variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#07bc0c', marginLeft: '16px', '&:hover': { backgroundColor: '#07bc0c', } }}>
                                <Verified />
                                <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Verified</Typography>
                            </Button> : (user?.role)?.toLowerCase() === 'admin' || (user?.role)?.toLowerCase() === 'checker' ? <Button onClick={() => setOpen(true)} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                                <Check />
                                <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Verify</Typography>
                            </Button> : null
                        }
                    </Stack> : null
                }
            </Stack>

            <Stack direction="row" justifyContent="right" gap={2} alignItems="center" mb={1}>
                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'center', alignItems: 'center' }}>
                    <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By:</Typography>
                            <small style={{ fontSize: "14px" }}>{lockerDetails?.createdUser ?? "N/A"}</small>
                        </Box>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created Date:</Typography>
                            <small style={{ fontSize: "14px" }}>{lockerDetails?.createdDate ? moment(lockerDetails?.createdDate).format('YYYY/M/D') : "N/A"}</small>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                    <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By:</Typography>
                            <small style={{ fontSize: "14px" }}>{lockerDetails?.updatedUser ?? "N/A"}</small>
                        </Box>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated Date:</Typography>
                            <small style={{ fontSize: "14px" }}>{lockerDetails?.updatedDate ? moment(lockerDetails?.updatedDate).format('YYYY/M/D') : "N/A"}</small>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                    <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By:</Typography>
                            <small style={{ fontSize: "14px" }}>{lockerDetails?.verifiedUser ?? "N/A"}</small>
                        </Box>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified Date:</Typography>
                            <small style={{ fontSize: "14px" }}>{lockerDetails?.verifiedDate ? moment(lockerDetails?.verifiedDate).format('YYYY/M/D') : "N/A"}</small>
                        </Box>
                    </Box>
                </Box>
            </Stack>

            <LayoutNewCustomerReg>
                <Container sx={{ width: "100%", marginBottom: '24px' }}>
                    <Grid container spacing={2}>
                        <Grid xs={12} item>
                            <Box>
                                <Grid container spacing={2}>
                                    {
                                        lockerDetails?.tempapprovalStatus === 3 ? <Grid item xs={12} md={12}>
                                            <Typography sx={{ color: "red", fontWeight: "700", fontSize: "10px" }}>
                                                Locker is set to delete. Note: This action cannot be undone if verified.
                                            </Typography>
                                        </Grid> : null
                                    }
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Locker Number:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamelockerNumber} value={lockerDetails?.lockerNumber} tempValue={lockerDetails?.templockerNumber} />

                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Locker Type:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamelockerType} value={lockerDetails?.lockerType} tempValue={lockerDetails?.templockerType} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Branch:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamebranchName} value={lockerDetails?.branchName} tempValue={lockerDetails?.tempbranchName} />

                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Location:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamelocationName} value={lockerDetails?.locationName} tempValue={lockerDetails?.templocationName} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Bin Number:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamebinNumber} value={lockerDetails?.binNumber} tempValue={lockerDetails?.tempbinNumber} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Key Number:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamekeyNumber} value={lockerDetails?.keyNumber} tempValue={lockerDetails?.tempkeyNumber} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Agreement Number:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSameagreementNumber} value={lockerDetails?.agreementNumber} tempValue={lockerDetails?.tempagreementNumber} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Vendor:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamevendorName} value={lockerDetails?.vendorName} tempValue={lockerDetails?.tempvendorName} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Rent Charge Frequency:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamerentChargeFrequencyName} value={lockerDetails?.rentChargeFrequencyName} tempValue={lockerDetails?.temprentChargeFrequencyName} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={6} md={6}>
                                        <KeyValueText>
                                            <KeyTxt>Status:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamelockerStatus} value={lockerDetails?.lockerStatus} tempValue={lockerDetails?.templockerStatus} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <KeyValueText>
                                            <KeyTxt>Description:</KeyTxt>
                                            <CustomerInfoText loading={lockerLoading} isSame={!lockerDetails?.isSamedescription} value={lockerDetails?.description} tempValue={lockerDetails?.tempdescription} />
                                        </KeyValueText>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
                {
                    isMainTable === 'true' ?
                        <BoxContainer >
                            <Typography component="div" mb={2} sx={{ color: "black", fontWeight: "700", fontSize: "20px" }}>
                                Locker History
                            </Typography>
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 460 }}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableHeadCell minwidth='15%'>Date Time</TableHeadCell>
                                                <TableHeadCell minwidth='20%'>Full Name</TableHeadCell>
                                                <TableHeadCell minwidth='20%'>Account Number</TableHeadCell>
                                                <TableHeadCell minwidth='10%'>Tran User</TableHeadCell>
                                                <TableHeadCell minwidth='10%' align='center'>Status</TableHeadCell>
                                                <TableHeadCell minwidth='25%'>Remarks</TableHeadCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                lockerLogs && lockerLogs.length > 0 ? lockerLogs.map((row: any, index: number) => (
                                                    <TableRow key={index}
                                                        sx={{
                                                            "&:last-child td, &:last-child th": {
                                                                border: 0,
                                                            },
                                                        }}
                                                    >
                                                        <TableCell align="left" style={{ fontSize: "12px" }}>
                                                            <TextLoading loading={lockerLoading} value={moment(row?.tranDate).format('YYYY/M/D hh:mm A')} />
                                                        </TableCell>
                                                        <TableCell align="left" style={{ fontSize: "12px" }}>
                                                            <TextLoading loading={lockerLoading} value={row?.name} />
                                                        </TableCell>
                                                        <TableCell align="left" style={{ fontSize: "12px" }}>
                                                            <TextLoading loading={lockerLoading} value={row?.accountNumber} />
                                                        </TableCell>
                                                        <TableCell align="left" style={{ fontSize: "12px" }}>
                                                            <TextLoading loading={lockerLoading} value={row?.tranUser} />
                                                        </TableCell>
                                                        <TableCell align="left" style={{ fontSize: "12px", display: "flex", flexDirection: "row" }}>
                                                            <Box sx={{
                                                                background: getStatusColor(row?.statusId),
                                                                borderRadius: "6px", padding: '6px 12px',
                                                                color: 'red'
                                                            }}>
                                                                <Typography
                                                                    sx={{ color: "white", fontWeight: '500', fontSize: '10px', textAlign: "center" }}>
                                                                    {row?.status}
                                                                </Typography>
                                                            </Box>
                                                            {
                                                                row?.statusId === 0 ? <Tooltip title="Print Release Form">
                                                                    <a style={{ marginLeft: '4px', height: '20px', color: 'gray', cursor: 'pointer' }} href='#' onClick={() => {
                                                                        setSelectedItem(row)
                                                                        setOpenPrint(true)
                                                                    }} rel="noreferrer">
                                                                        <Print />
                                                                    </a>
                                                                </Tooltip> : null
                                                            }
                                                        </TableCell>
                                                        <TableCell align="left" style={{ fontSize: "12px" }}>
                                                            <TextLoading loading={lockerLoading} value={row?.remarks} />
                                                        </TableCell>
                                                    </TableRow>
                                                )) : <TableRow>
                                                    <TableCell colSpan={6} align="center">No Data Found</TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {(lockerLogs?.length > 0) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
                            </Paper>
                        </BoxContainer>
                        : null
                }
            </LayoutNewCustomerReg>

            <Modal
                open={openPrint}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: '80%', height: '90%', overflowY: 'scroll' }} mt={8} textAlign={'left'}>
                    <LockerReleaseFormTemplate selectedItem={selectedItem} />
                </Box>
            </Modal>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to approve?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If cancel, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <LoadingButton loading={lockerLoading} onClick={handleApproveLocker} variant='contained' color='success'>Yes</LoadingButton>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </Box >
    );
}

const TopBreadcrumbs = () => {
    const location = [{ name: "Lockers", to: "/lockers" }, { name: "Details" }]
    return (
        <BreadCrum location={location} />
    );
}

export default LockerDetails;